module.exports = __webpack_public_path__ + "static/media/python.6606c48f.png";